import React, { Component } from "react";
import Header from "../../Components/MainLayout/Header";
import { connect } from "react-redux";
import axios from "axios";
import Authorize from "../../../global/Authorize";
import Skeleton from "react-loading-skeleton";
import noData from "../../Assets/img/noData.png";

const mapStateToProps = ({ dispatch, user }) => ({
  dispatch,
  user,
});

class Notificaations extends Component {
  constructor(props) {
    super(props);
    this.state = {
      notification_data: null,
      loading: true,
      fakeData: [1, 2, 3, 4],
    };
  }

  componentDidMount() {
    window.scrollTo(0, 0);
    document.title = "Today Birthday";
    this.fetchStudentBirthday({
      session: this.props.user.session.id,
    });
  }

  fetchStudentBirthday = (params = {}) => {
    axios
      .get("mApiV1/StudentBirthday", { params: { ...params } })
      .then((res) => {
        this.setState({ notification_data: res.data, loading: false });
      })
      .catch((error) => {
        this.setState({ loading: false });
      });
  };
  render() {
    return (
      <Authorize
        roles={["IS_TEACHER", "IS_ADMIN", "IS_SUPERADMIN", "IS_PRINCIPAL"]}
        redirect
        to="/login"
      >
        <Header to="/home" title="Today Birthday" />
        <div className="container my-3 col-12">
          <p className="mt-3 mb-0 th-12 th-bold">Today's Birthday</p>
          {this.state.loading
            ? this.state.fakeData?.map((item, index) => {
                return (
                  <div
                    key={index}
                    className="border p-3 shadow-sm rounded-lg mt-3"
                  >
                    <Skeleton width={150} />
                    <Skeleton />
                  </div>
                );
              })
            : null}

          {this.state.notification_data?.length !== 0 &&
          this.state.loading === false ? (
            <div>
              <p className="mb-3 th-12 ">
                Wish your students directly on whatsapp.
              </p>
              {this.state.notification_data?.map((item, index) => {
                return (
                  <div className="mb-3" key={index}>
                    <div className="border shadow-sm p-3 rounded">
                      <div className="d-flex align-items-center justify-content-between">
                        <div>
                          <div className="th-12 th-medium">
                            {item.user__first_name}
                          </div>
                          <div className="th-12 th-grey">
                            {item.student_class__class_name}{" "}
                            {item.section__section_name}
                          </div>
                        </div>
                        {item.user__whatsapp_number ? (
                          <a
                            className="my-auto"
                            href={`https://api.whatsapp.com/send?phone=${item.user__whatsapp_number}&text=Happy Birthday ${item.user__first_name}`}
                            target="_blank"
                          >
                            <i
                              className="fa fa-whatsapp text-success th-24"
                              aria-hidden="true"
                            ></i>
                          </a>
                        ) : null}
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          ) : null}

          {this.state.notification_data?.length === 0 &&
          this.state.loading === false ? (
            <div className="px-5 py-5">
              <img className="w-100 mt-5" src={noData} alt="No Data Found" />
              <p className="text-center th-14 th-bold mt-5">
                No Birthdays Today!
              </p>
            </div>
          ) : null}
        </div>
      </Authorize>
    );
  }
}

export default connect(mapStateToProps)(Notificaations);
